module.exports = __webpack_public_path__ + "static/media/AccountSetting.a2157db3.svg";